import React, {
  createContext,
  ReactNode,
  useContext,
  useEffect,
  useState,
} from "react";
import { AwsRum, AwsRumConfig } from "aws-rum-web";

import { env } from "~/env";

export type AwsRumContextType = AwsRum | null;

const AwsRumContext = createContext<AwsRumContextType>(null);

interface AwsRumProviderProps {
  children: ReactNode;
}

export const AwsRumProvider: React.FC<AwsRumProviderProps> = ({ children }) => {
  const [awsRum, setAwsRum] = useState<AwsRum | null>(null);

  useEffect(() => {
    try {
      const config: AwsRumConfig = {
        sessionSampleRate: 1,
        guestRoleArn: env.VITE_AWS_RUM_GUEST_ROLE_ARN,
        identityPoolId: env.VITE_AWS_RUM_IDENTITY_POOL_ID,
        endpoint: env.VITE_AWS_RUM_ENDPOINT,
        telemetries: ["performance", "errors", "http"],
        allowCookies: true,
        enableXRay: false,
      };

      const awsRum = new AwsRum(
        env.VITE_AWS_RUM_APPLICATION_ID,
        env.VITE_AWS_RUM_APPLICATION_VERSION,
        env.VITE_AWS_RUM_APPLICATION_REGION,
        config,
      );

      setAwsRum(awsRum);
    } catch (error) {
      console.error("AWS RUM initialization error:", error);
    }
  }, []);

  return (
    <AwsRumContext.Provider value={awsRum}>{children}</AwsRumContext.Provider>
  );
};

export const useAwsRum = (): AwsRumContextType => {
  return useContext(AwsRumContext);
};
